import Navbar from "./components/Navbar";
import { Hero } from "./components/Hero";
import { FeaturesSectionWithHoverEffects } from "./components/FeaturesHover";
import { FooterCTA } from "./components/FooterCTA";
import ShaderBackground from "./components/ShaderBackground";
import { HeroWithMarquee } from "./components/HeroWithMarquee";
import "./index.css";

export function App() {
  return (
    <div>
      <div className="pointer-events-none fixed inset-0 -z-10">
        <ShaderBackground />
      </div>
      <Navbar />
      <Hero />
      <HeroWithMarquee />
      <FeaturesSectionWithHoverEffects />
      <FooterCTA />
    </div>
  );
}

export default App;


